import { Controller } from '@hotwired/stimulus';

/**
 * remark-auto-open
 *
 * On the CR document page, `?remarque=<observation_id>` (minted by the cockpit
 * cards) auto-opens that remarque's slide-over by clicking its table row — reusing
 * the row's own slide-over-trigger wiring (never duplicating frame/src logic).
 * Rows carry data-obs-id (Task 9). No-op when the row is absent (remarque not in
 * this CR) or inert (portal MOA). One shot per page load.
 */
export default class extends Controller {
  connect() {
    // Review G7 — never fire during a Turbo cache-preview paint (back-button
    // restore would double-open the panel).
    if (document.documentElement.hasAttribute('data-turbo-preview')) return;

    const url = new URL(window.location.href);
    const id = url.searchParams.get('remarque');
    if (!id) return;

    const row = this.element.querySelector(`tr[data-obs-id="${CSS.escape(id)}"]`);
    if (row && row.dataset.controller?.includes('slide-over-trigger')) {
      // Defer one tick so the row's own Stimulus controller is connected.
      requestAnimationFrame(() => row.click());
    }
    // One-shot: strip the param so refresh/back never re-opens (review G7).
    url.searchParams.delete('remarque');
    window.history.replaceState(window.history.state, '', url);
  }
}
